import LoggedInRoute from './LoggedInRoute';
export default LoggedInRoute;
